export enum CentricPOTypeEnum {
    SOLID = 'SOLID',
    PPK = 'PPK',
    BOTH = 'BOTH'
}